"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importDefault(require("react"));
var styles_1 = require("../styles");
var styles = {
    /* Styles applied to the root element. */
    root: {
        display: 'flex',
        padding: '8px 24px',
    },
};
// interface UnstyledCompactAccordionDetailsProps extends WithStyles<CompactAccordionDetailsClassKey>, HTMLProps<HTMLDivElement> {
//   children: ReactNode,
//   className?: string,
// }
function UnstyledCompactAccordionDetails(_a) {
    var classes = _a.classes, children = _a.children, className = _a.className, other = __rest(_a, ["classes", "children", "className"]);
    return (react_1.default.createElement("div", __assign({ className: (0, clsx_1.default)(classes.root, className) }, other), children));
}
var CompactAccordionDetails = (0, styles_1.withStyles)(styles, { name: 'CompactAccordionDetails' })(UnstyledCompactAccordionDetails);
exports.default = CompactAccordionDetails;
//# sourceMappingURL=CompactAccordionDetails.js.map